module.exports = __webpack_public_path__ + "static/media/Orcamentos1.1afd97da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos1.png
// module id = 2097
// module chunks = 0